export const MOCK_BILLS = [
  {
    id: "1",
    billId: "BILL-SA1-003",
    account: "Oak Hill Residence",
    accountAvatar: "OH",
    period: "August 2024",
    amount: "$119.32",
    status: "Paid",
    isOverdue: false,
    dueDate: "Paid Sep 14, 2024",
    consumption: "12.4 CCF"
  },
  {
    id: "2",
    billId: "BILL-SA2-003",
    account: "Wadsworth Apt 3B",
    accountAvatar: "WA",
    period: "August 2024",
    amount: "$74.55",
    status: "Paid",
    isOverdue: false,
    dueDate: "Paid Sep 20, 2024",
    consumption: "7 CCF"
  },
  {
    id: "3",
    billId: "BILL-SA3-003",
    account: "Corporate Center",
    accountAvatar: "CC",
    period: "August 2024",
    amount: "$268.90",
    status: "Paid",
    isOverdue: false,
    dueDate: "Paid Sep 25, 2024",
    consumption: "26.8 CCF"
  },
  {
    id: "4",
    billId: "BILL-SA1-002",
    account: "Oak Hill Residence",
    accountAvatar: "OH",
    period: "September 2024",
    amount: "$84.66",
    status: "Unpaid",
    isOverdue: true,
    dueDate: "Oct 20, 2024",
    consumption: "8.1 CCF"
  },
  {
    id: "5",
    billId: "BILL-SA2-002",
    account: "Wadsworth Apt 3B",
    accountAvatar: "WA",
    period: "September 2024",
    amount: "$70.20",
    status: "Paid",
    isOverdue: false,
    dueDate: "Paid Oct 18, 2024",
    consumption: "6.5 CCF"
  },
  {
    id: "6",
    billId: "BILL-SA3-002",
    account: "Corporate Center",
    accountAvatar: "CC",
    period: "September 2024",
    amount: "$312.80",
    status: "Paid",
    isOverdue: false,
    dueDate: "Paid Oct 28, 2024",
    consumption: "31.2 CCF"
  },
  {
    id: "7",
    billId: "BILL-SA1-001",
    account: "Oak Hill Residence",
    accountAvatar: "OH",
    period: "October 2024",
    amount: "$86.07",
    status: "Unpaid",
    isOverdue: true,
    dueDate: "Nov 20, 2024",
    consumption: "9.2 CCF"
  },
  {
    id: "8",
    billId: "BILL-SA2-001",
    account: "Wadsworth Apt 3B",
    accountAvatar: "WA",
    period: "October 2024",
    amount: "$62.99",
    status: "Unpaid",
    isOverdue: true,
    dueDate: "Nov 25, 2024",
    consumption: "5.8 CCF"
  },
  {
    id: "9",
    billId: "BILL-SA3-001",
    account: "Corporate Center",
    accountAvatar: "CC",
    period: "October 2024",
    amount: "$285.40",
    status: "Paid",
    isOverdue: false,
    dueDate: "Paid Nov 01, 2024",
    consumption: "28.4 CCF"
  }
];

export const MOCK_PAYMENTS = [
  {
    id: "1",
    account: "Corporate Center",
    accountAvatar: "CC",
    billId: "BILL-SA3-001",
    period: "October 2024",
    amountPaid: "$285.40",
    paidDate: "Nov 01, 2024",
    method: "Auto-Paid"
  },
  {
    id: "2",
    account: "Corporate Center",
    accountAvatar: "CC",
    billId: "BILL-SA3-002",
    period: "September 2024",
    amountPaid: "$312.80",
    paidDate: "Oct 28, 2024",
    method: "Auto-Paid"
  },
  {
    id: "3",
    account: "Wadsworth Apt 3B",
    accountAvatar: "WA",
    billId: "BILL-SA2-002",
    period: "September 2024",
    amountPaid: "$70.20",
    paidDate: "Oct 18, 2024",
    method: "Auto-Paid"
  },
  {
    id: "4",
    account: "Corporate Center",
    accountAvatar: "CC",
    billId: "BILL-SA3-003",
    period: "August 2024",
    amountPaid: "$268.90",
    paidDate: "Sep 25, 2024",
    method: "Auto-Paid"
  },
  {
    id: "5",
    account: "Wadsworth Apt 3B",
    accountAvatar: "WA",
    billId: "BILL-SA2-003",
    period: "August 2024",
    amountPaid: "$74.55",
    paidDate: "Sep 20, 2024",
    method: "Auto-Paid"
  },
  {
    id: "6",
    account: "Oak Hill Residence",
    accountAvatar: "OH",
    billId: "BILL-SA1-003",
    period: "August 2024",
    amountPaid: "$119.32",
    paidDate: "Sep 14, 2024",
    method: "Manual Payment"
  }
];
